import {deployments, globalStores, site} from '@stores'

export class DevStore {
  addSshToClipboard = async (e) => {
    if (DEBUG) {
      const {selectedDeployment} = deployments
      const sshCommand = `ssh -i ./secret/centric-innovation-test.pem ubuntu@${_.trim(selectedDeployment.url, '/').replace('http://', '').replace('https://', '')}`
      await navigator.clipboard.writeText(sshCommand)
      globalStores.catalog.dialogs.showToastMessage(`Copied ssh command to clipboard`)
      console.log(sshCommand)
    }
  }
}

export const dev = DEBUG ? new DevStore() : null


// WEBPACK FOOTER //
// ./src/modules/dev/DevStore.ts